import React, { type FC } from 'react'
import { Link } from 'react-router'
import { fundsManagementTracker } from '@mobi/account/Common/Analytics'
import { routes } from '@mobi/account/Utils'
import { type PaymentMethodsAll } from '@mobi/component-library/Areas/Deposit/types'
import { CustomerServiceCentre, CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import { useHostContext } from '../../../Common/HostContext'
import { paymentMethodTypeNameMap } from '../Utils/schema'

type Props = {
  paymentMethod: PaymentMethodsAll
  asModal?: boolean
}

export const PaymentMethodBlocked: FC<Props> = ({ paymentMethod, asModal }) => {
  return (
    <InfoBox size='md' color={paymentMethod === 'PayID' ? 'red' : 'orange'}>
      <BlockedPaymentMethodText paymentMethod={paymentMethod} asModal={asModal} />
    </InfoBox>
  )
}

PaymentMethodBlocked.displayName = 'PaymentMethodBlocked'

const BlockedPaymentMethodText: FC<Props> = ({ paymentMethod, asModal }) => {
  const { channel } = useHostContext()

  const blockDebitCardText = asModal ? (
    <span>Block Debit Card</span>
  ) : (
    <Link to={routes.blockDebitCard}>Block Debit Card</Link>
  )

  const customerServiceText =
    paymentMethod === 'CreditCard' && channel === 'mobile' ? (
      <>
        Please check your settings on the {blockDebitCardText} page or call us on{' '}
        <CustomerServiceTelephone
          onClick={() =>
            fundsManagementTracker({ interaction_type: 'Need Assistance', location: 'Deposit' })
          }
        />{' '}
        for more information.
      </>
    ) : (
      <CustomerServiceCentre
        onClickPhoneNumber={() =>
          fundsManagementTracker({ interaction_type: 'Need Assistance', location: 'Deposit' })
        }
      />
    )
  return (
    <div>
      <strong>
        Deposits are not enabled for {paymentMethodTypeNameMap[paymentMethod]} on this account.
        {paymentMethod === 'PayID' &&
          ' Any deposits to this PayID will be automatically refunded to your bank account.'}
      </strong>
      <br />
      {customerServiceText}
    </div>
  )
}
